//@ts-nocheck
import * as yup from "yup";

let createUserValidationForm = yup.object().shape({
  full_name: yup.string().required("Name is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  username: yup.string().required("UserName is required"),
  email: yup.string().required("Email is required"),
});

let changePasswordValidationForm = yup.object().shape({
  old_password: yup.string().required("Old Password is required"),
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});

export { changePasswordValidationForm, createUserValidationForm };
